import http from '../../utils/fetch';
export default {
    //查询付款计划
    selectFkList(entity){
        return http({
            url: '/api/swyl/v1/demo/bscSrmPayment/selectFkList',
            method: 'post',
            params: entity
        });
    },
    //冷库专用生成虚拟预测id
    createKoukuanFjId() {
        return http({
            url: '/api/swyl/v1/demo/bscSrmPayment/createFjId',
            method: 'post',
        });
    },
    //查询付款计划
    insertFkData(entity){
        return http({
            url: '/api/swyl/v1/demo/bscSrmPayment/insertFkData',
            method: 'post',
            data: entity
        });
    },
    //提交付款并发起审批
    paymentAndApproval(entity){
        return http({
            url: '/api/swyl/v1/demo/bscSrmPayment/paymentAndApproval',
            method: 'post',
            data: entity
        });
    },
    //提交付款并发起审批
    approvalPayment(entity){
        return http({
            url: '/api/swyl/v1/demo/bscSrmPayment/approvalPayment',
            method: 'post',
            data: entity
        });
    },
    //根据id获取付款信息详情
    getFukuanDataById(query){
        return http({
            ///api/swyl/v1/mubiao/userDailyTargetProject/selectProList?projectName=
            url: '/api/swyl/v1/demo/bscSrmPayment/getFukuDataById?id=' + query,
            method: 'post',
            //data: query
        });
    },
    //根据id删除被gems驳回的数据
    deleteByIds(entity){
        return http({
            url: '/api/swyl/v1/demo/bscSrmPayment/deleteByIds',
            method: 'post',
            data: entity
        });
    },
    //查询付款计划
    selectPage(entity){
        return http({
            url: '/api/swyl/v1/demo/bscSrmPayment/selectPage',
            method: 'post',
            params: entity
        });
    },
    //根据instId查询付款表
    selectPageByInstId(entity){
        return http({
            url: '/api/swyl/v1/demo/bscSrmPayment/selectPageByInstId',
            method: 'post',
            params: entity
        });
    },

    baseurl: '/api/swyl/v1/demo',


    //查看分页列表
    page(query) {
        return http({
            url: this.baseurl + '/bscSrmInvoiceApply/selectPage',
            method: 'post',
            params: query
        });
    },
    //查询未开票明细
    selectUnInvoice(query) {
        return http({
            url: this.baseurl + '/bscSrmInvoiceDetail/selectUnInvoiceList',
            method: 'post',
            params: query
        });
    },
    //保存开票申请
    saveApply(query) {
        return http.post(this.baseurl + '/bscSrmInvoiceApply/insert', query);
    },
    //提交开票申请
    subApply(query) {
        return http.post(this.baseurl + '/bscSrmInvoiceApply/submit', query);
    },
    //删除发票申请
    deleteApply(query) {
        return http({
            url: this.baseurl + '/bscSrmInvoiceApply/deleteById',
            method: 'post',
            params: query
        });
    },
    //获取申请单
    selectApplyById(id){
        return http({
            url: this.baseurl + '/bscSrmInvoiceApply/selectById',
            method: 'post',
            params: {id:id}
        });
    },
    //修改时获取未开票的明细
    selectUpdateUnInvoice(id,companyCode){
        return http({
            url: this.baseurl + '/bscSrmInvoiceDetail/selectUpdateUnInvoice',
            method: 'post',
            params: {applyId:id,companyCode:companyCode}
        });
    },
    //审核申请单
    shpsaveOrSubmit(params) {
        return http({
            url: this.baseurl + '/bscSrmInvoiceApply/checkApply',
            method: 'post',
            data: params
        });
    },
    //保存发票
    saveInvoice(query) {
        return http.post(this.baseurl + '/bscSrmInvoice/saveInvoice', query);
    },
    //保存发票
    saveInvoiceTs(query) {
        return http.post(this.baseurl + '/bscSrmInvoice/saveInvoiceTs', query);
    },
    //发票列表
    pageInvoice(query) {
        return http({
            url: this.baseurl + '/bscSrmInvoice/selectPage',
            method: 'post',
            params: query
        });
    },
    //根据发票id查询明细
    selectDetialByInvoice(id){
        return http({
            url: this.baseurl + '/bscSrmInvoiceDetail/selectByInvoiceId',
            method: 'post',
            params: {invoiceId:id}
        });
    },
    //获取发票信息
    selectInvoiceById(id){
        return http({
            url: this.baseurl + '/bscSrmInvoice/selectById',
            method: 'post',
            params: {id:id}
        });
    },
    //删除发票
    deleteInvoice(query) {
        return http({
            url: this.baseurl + '/bscSrmInvoice/deleteById',
            method: 'post',
            params: query
        });
    },
    //修改发票
    updateInvoice(query) {
        return http.post(this.baseurl + '/bscSrmInvoice/updateById', query);
    },

    //根据供应商和对账公司查询
    selectInvoices(query) {
        return http({
            url: this.baseurl + '/bscSrmInvoiceDetail/selectInvoicesPage',
            method: 'post',
            params: query
        });
    },

    //根据供应商和对账公司查询
    invoiceList(query) {
        return http({
            url: this.baseurl + '/bscSrmInvoiceDetail/invoiceListPage',
            method: 'post',
            params: query
        });
    },
    //数据传srm
    sendSrmByInvoice(query) {
        return http({
            url: this.baseurl + '/bscSrmInvoiceDetail/sendSrmByInvoice',
            method: 'post',
            data: query
        });
    },
    //查询对账信息
    selectIssueBill(entity){
        return http({
            url: '/api/swyl/v1/demo/bscSrmPayment/getIssueBill',
            method: 'post',
            params: entity
        })
    },
    //发票列表查询
    selectNewPage(entity){
        return http({
            url: '/api/swyl/v1/demo/bscInvoiceSrm/selectPage',
            method: 'post',
            params: entity
        });
    },
    //发票xml查看
    getEinvoiceByXmlFile(url){
        return http({
            url: '/api/swyl/v1/demo/bscInvoiceSrm/getEinvoiceByXmlFile?url='+url,
            method: 'post',
        });
    },
    //根据发票id查询明细
    selectDetialById(id){
        return http({
            url: '/api/swyl/v1/demo/bscInvoiceSrm/selectById',
            method: 'post',
            params: {id:id}
        });
    },

    //获取发票附件
    selectInvoiceFile(entity){
        return http({
            url: '/api/swyl/v1/demo/bscInvoiceSrm/selectInvoiceFile',
            method: 'post',
            params: entity
        });
    },


    //批量冻结
    freezeSrmByInvoiceList(query){
        return http({
            url: '/api/swyl/v1/demo/bscSrmInvoiceDetail/freezeSrmByInvoiceList',
            method: 'post',
            data: query
        });
    },

    //批量解冻
    thawSrmByInvoiceList(query){
        return http({
            url: '/api/swyl/v1/demo/bscSrmInvoiceDetail/thawSrmByInvoiceList',
            method: 'post',
            data: query
        });
    },

    //一票到底列表查询
    selectInvoiceTheEnd(query){
        return http({
            url: '/api/swyl/v1/demo/bscSrmInvoiceDetail/selectInvoiceTheEndPage',
            method: 'post',
            params: query
        });
    },
    // 可开票 退税  api/swyl/v1/demo/bscTaxInvoice/selectPage
    selectPageDrawback(query){
        return http({
            url: '/api/swyl/v1/demo/bscTaxInvoice/selectPage',
            method: 'post',
            params: query
        });
    },
    // 可开票 退税  api/swyl/v1/demo/bscTaxInvoice/selectPage
    transferSupplier(query){
        return http({
            url: '/api/swyl/v1/demo/bscTaxInvoice/transferSupplier',
            method: 'post',
            data: query
        });
    },

    //根据供应商和对账公司查询
    selectTaxSupplier(query) {
        return http({
            url: '/api/swyl/v1/demo/bscTaxInvoice/selectSupplierPage',
            method: 'post',
            params: query
        });
    },
    //根据供应商和对账公司查询
    selectSupplierTablePage(query) {
        return http({
            url: '/api/swyl/v1/demo/bscTaxInvoice/selectSupplierTablePage',
            method: 'post',
            params: query
        });
    },


    //调用影像发票识别接口
    vatInvoiceRecognize(filId) {
        return http({
            url: '/api/swyl/v1/demo/bscInvoiceSrm/vatInvoiceRecognize?filId='+filId,
            method: 'post',
            params: filId
        });
    },

    getSupplierBank(codeOrName) {
        return http({
            url: '/api/swyl/v1/test/bscUserInfoSupplierCopy/getSupplierBank?codeOrName='+codeOrName,
            method: 'post',
            params: codeOrName
        });
    }


}
